export default {
	title: 'Warn Handle',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		deleteSuccess: 'Delete successful',
		actionSuccess: 'Operation successful',
		requiredError: 'Required field cannot be empty'
	},
	buttons: {
		add: 'Add',
		batchDelete: 'Batch Delete',
		edit: 'Edit',
		delete: 'Delete',
		export: 'Export',
		exportAll: 'Export All',
		exportSelected: 'Export Selected'
	},
	table: {
		warnTitle: 'Warn Title',
		projName: 'Project Name',
		deviceName: 'Device Name',
		pointName: 'Point Name',
		orgName: 'Organization',
		warnLevel: 'Warn Level',
		warnTime: 'Warn Time',
		featureValue: 'Feature Value',
		content: 'Content',
		handleAction: 'Handle Action',
		reviewResult: 'Review Result',
		correct: 'Correct',
		incorrect: 'Incorrect',
		handler: 'Handler',
		handleTime: 'Handle Time',
		action: 'Action'
	},
	form: {
		placeholder: {
			projName: 'Project Name',
			deviceName: 'Device Name',
			pointName: 'Point Name',
			orgId: 'Organization',
			startTime: 'Start Time',
			endTime: 'End Time'
		},
		label: {
			gearName: 'Gear Name',
			gearBrand: 'Gear Brand',
			bpfo: 'BPFO',
			bpfi: 'BPFI',
			bsf: 'BSF',
			ftf: 'FTF'
		}
	},
	config: {
		gridLayout: 'Grid Layout'
	},
	dialog: {
		add: 'Add',
		update: 'Edit'
	}
}
